<template>
  <div class="box-shadow" v-if="can_access('deal','upload') || can_access('stock','upload') || can_access('marketvalue','upload') || can_access('fxrate','upload')">
  <form @submit.stop.prevent ref="form" class="col-md-12">
    <div class="form-group input-field">
        <label class="active">Docs</label>
        <input type="file" ref="file" class="mb-2" :disabled="!allow_upload"/><br>
        <a :href="sample_download_url" v-if="sample_file" target="_blank">sample csv</a>
        <h6 class="mt-1" style="font-size:0.700rem;">{{note}}</h6>
    </div>
    
    <div v-if="showTableView">
      <h6 class="mt-1" style="color:red;">DATE FORMAT SHOULD BE <b>DD-MM-YYYY / YYYY-MM-DD</b>. INVALID FORMAT MAY AFFECT PREVIOUS DATA.</h6>
      <h3 class="mt-3 p-0" v-if="totalUploaded">Total Deals: <strong>{{totalUploaded}}</strong>, Success: <strong style="color:green">{{Successful}}</strong>, Failed: <strong style="color:red">{{failed}}</strong></h3>
      <TableView :col="columns" :getData="getData"/> 
    </div>

    <div v-if="!totalUploaded">
      <h6 v-if="showTableView">I have verified all the entries and proceed for upload.</h6>
      <button class="btn btn-lg btn-info" @click="document_upload(0)" :disabled="btn_disabled">Upload</button>

      <h5 class="mt-3" v-if="module=='deal' && showTableView">If you find "Existing Contract" error on preview, you can <a href="javascript:;" @click="document_upload(1)"><strong>Force upload</strong></a> to add as a new deal ticket</h5>
      <h6 class="" style="color:red" v-if="module=='deal' && showTableView">Warning: Force upload will not check duplicate entries. Ensure your data don’t have duplicate entries</h6>
      <!-- <a :href="download_url" v-if="can_access('deal','upload') && download_url" class="btn btn-lg btn-info" target="_blank" ref="download_response_csv">Download Response</a> -->

      <h6 class="mt-4" v-if="module=='deal' && showTableView">*NOTE:<br>New- New deal ticket<br>Existing Contract Note- There are another deal ticket(s) with same details (Qty, price etc) for the same account number<br>Invalid- There is error in Excel values (Eg: Side)</h6>
    </div>

    <div v-if="totalUploaded && error_csv_path" style="display:flow-root">
      <button class="btn btn-lg btn-info pull-right" @click="download_csv">Download CSV</button>
    </div>
  </form>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
import { mapActions } from 'vuex';
export default {
  name: "UploadTradesCSV",
  mixins: [common],
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  props: {uri:{},sample_file:{},note:{},check_verified:{ type: Boolean,default:false},module},
  data(){
    return {
      showTableView: false,
      res: {},
      docs_type: "",
      file: '',
      btn_disabled: false,
      allow_upload: true,
      download_url: '',
      error_csv_path: '',
      totalUploaded: 0,
      Successful: 0,
      failed: 0,
      sample_download_url: this.get_baseURL()+this.sample_file+'?api_token='+ window.localStorage.getItem('auth_token'),
      formInput: {
        files : ""
      },
      verified: this.check_verified,
      columns: (() => {
        const cols = []
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('report', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
    }
  },
  methods:{
    ...mapActions('layout', ['changeBodyLoading']),
    document_upload(forced=false){
      this.changeBodyLoading(true);
      //console.log(this.uri,$(this.$refs.file)[0].files.length)
      if(this.uri && $(this.$refs.file)[0].files.length){
        if(this.verified) this.btn_disabled = true;
        this.allow_upload = false;
        let formData = new FormData();
        formData.append('docs', $(this.$refs.file)[0].files[0]);
        formData.append('verified',this.verified);
        if(forced) formData.append('forced',1);
        this.call_axios(this.uri,'post', formData).then(response => {
          if(response.response.code==0){
            if(!this.verified){
              this.res = response;
              this.columns = [
                /* { title: 'Date', field: 'date', tdStyle: {padding: "0.8rem !important"}}, */
              ];
              Object.keys(response.response.data.result[0]).forEach((v) => {
                /* if(v!='date') */
                if(v=='action')
                  this.columns.push({ title: v.toUpperCase(), field: v, tdStyle: (row) => {if(["New","Created"].indexOf(row.action)>=0) return {color: "green"};else return {color: 'red'};} });
                else this.columns.push({ title: v.toUpperCase(), field: v });
              })
              this.showTableView = true;
              this.verified = true;
              this.changeBodyLoading(false);
              return;
            }
            this.changeBodyLoading(false);
            if(response.response.data.result && response.response.data.result.length && response.response.data.result[0].hasOwnProperty('action')){
              this.Successful = 0;
              this.failed = 0;
              this.res = response;
              this.res.response.data.result = this.res.response.data.result.filter(item => {
                if(item.action=='Created') this.Successful += 1;
                else this.failed += 1;
                return item.action!='Created'
              })
              this.showTableView = false;
              this.$nextTick(() => {
                this.error_csv_path = this.res.response.data.error_file;
                this.totalUploaded = this.res.response.data.total;
                this.showTableView = true;
              })
              return;
            }
            this.$toasted.success("Documents uploaded successfully",{duration:1500});
            this.download_url = response.data;
            this.$emit('forceRerender',response.response);
          }else{
            this.changeBodyLoading(false);
            this.$refs.form.reset();
            this.btn_disabled = false;
            this.allow_upload = true;
            this.$toasted.error("Not a valid document!",{duration:1500});
          }
        });
      }
    },
    download_csv(){
      this.$emit('forceRerender',this.res.response);
      window.open(this.get_baseURL() +'download_files?api_token='+ window.localStorage.getItem('auth_token')+'&filename='+this.error_csv_path, '_blank');
    },
    async getData(query, filter) {
      this.res.response.data.Pagination = false;
      return this.res;
    }
  }
}
</script>